
import './formDetalle.scss'
import { useState, useEffect, useContext } from "react";
import { OfertasDetFormContext } from '../../../../../context/ofertasdet/OfertasDetContext';
import loadingGif from '../../../../../assets/uploading.gif';
import ArticulosModal from '../../../../articulos/articulosModal/articulosModal';
import { getOfertaDetPanel } from '../../../../../services/OfertasDetServices';
import ConfirmationDialog from "../../../../../components/dialogs/ConfirmationDialog";
import ErrorDialog from "../../../../../components/dialogs/ErrorDialog";

export const FormDetalle = ({
  aofid,
  iddet,
  tipooferta,
  tipoprecio,
  addItem,
  getItem,
  updateItem,

  arrayDetalle,
  ultimoID,
  closeModal
}) => {

  const {
    report,
    getOfertaDetByIdData,
    patchOfertaDetData,
    getArticuloByIdData,
  } = useContext(OfertasDetFormContext);
  const [title, setTitle] = useState('');
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [searchIdArt, setSearchIdArt] = useState();
  const [searchDescArt, setSearchDescArt] = useState();
  const [selectedRow, setSelectedRow] = useState();

  // Vista Previa
  const [uploadFormError, setUploadFormError] = useState('');  // Para el mensaje de error de imagen
  // estado de carga
  const [isSubmitting, setIsSubmitting] = useState(false);
  // estado de edicion o creacion
  const [estadoForm, setEstadoForm] = useState('');
  
  // Estado para controlar la apertura de los diálogos
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    iddet ? setTitle('Editar Articulo de Oferta') : setTitle('Agregar Articulo de Oferta');
  }, [iddet])


  useEffect(() => {
    const fetchData = async () => {
      if (iddet) {
        // Verificar si el detalle está en el array
        const detalleEnArray = arrayDetalle.find((item) => item.id === iddet);
         
        if (detalleEnArray) {
          if (detalleEnArray) {
            setForm((prevForm) => ({
              ...prevForm,
              art_descripcion: detalleEnArray?.oferta_Art?.art_descripcion || prevForm.art_descripcion || "",
              ...detalleEnArray, // Usa detalleEnArray correctamente si es un objeto plano
            }));
            setEstadoForm(1);
          }
          setEstadoForm(1);
        } else {
          try {
            // Si el ID no está en el array, buscar los datos desde la API
            const detalle = await getOfertaDetByIdData(iddet);
            if (detalle) {
              const articulo = await getArticuloByIdData(detalle.art_Id);
              setForm(prevForm => ({
                ...prevForm,
                ...detalle,
                art_descripcion: articulo?.art_descripcion || '',
                art_codigo: articulo?.art_codigo || '',
              }));
          setEstadoForm(1);
            } else {
              console.error("No se encontraron datos para el ID proporcionado.");
            }
          } catch (error) {
            console.error("Error al obtener los datos desde la API:", error);
          }
        }
      }
    };

    fetchData(); // Llamar a la función asíncrona dentro de useEffect
  }, [aofid, iddet]);

  const handleSelectArticulo = (art_id, art_codigo, art_descripcion, art_npreciocosto, preciobuscado) => {
    const nuevoPrecio = Number(preciobuscado);
    const margenActual = ((nuevoPrecio - art_npreciocosto) / art_npreciocosto) * 100;
    setForm((prevForm) => ({
      ...prevForm,
      art_Id: art_id,
      art_codigo: art_codigo,
      art_descripcion: art_descripcion,
      aofd_ofertacosto: art_npreciocosto.toFixed(2),
      aofd_art_nprecio: Number(nuevoPrecio).toFixed(2),
      aofd_margenactual: Number(margenActual).toFixed(2),
      aofd_ofertadescto: 0,
      aofd_ofertaprecio: 0,
      aofd_margen: 0
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target; 

    setForm((prevForm) => {
      let updatedForm = { ...prevForm }; 

      validateInput(name, value);  
      updatedForm[name] = value;

      // Si se actualiza aofd_ofertaprecio, recalcula aofd_ofertadescto y aofd_margen
      if (name === "aofd_ofertaprecio" && updatedForm.aofd_art_nprecio) {
        const descuento = ((1 - (value / updatedForm.aofd_art_nprecio)) * 100).toFixed(2);
        const margen = ((value - updatedForm.aofd_ofertacosto) / updatedForm.aofd_ofertacosto * 100).toFixed(2);
        updatedForm.aofd_ofertadescto = Number(descuento);
        updatedForm.aofd_margen = Number(margen);
      }

      // Si se actualiza aofd_ofertadescto, recalcula aofd_ofertaprecio y aofd_margen
      if (name === "aofd_ofertadescto" && updatedForm.aofd_art_nprecio) {
        const precio = (updatedForm.aofd_art_nprecio * ((100 - value) / 100)).toFixed(2);
        const margen = ((precio - updatedForm.aofd_ofertacosto) / updatedForm.aofd_ofertacosto * 100).toFixed(2);
        updatedForm.aofd_ofertaprecio = Number(precio);
        updatedForm.aofd_margen = Number(margen);
      }

      return updatedForm;  
    });
  };

  const validateInput = (name, value) => {
    let formErrors = {};
    if (name === "aofd_ofertaprecio") {
      const regex = /^\d+(\.\d{1,3})?$/;

      if (!regex.test(value) && value !== "") {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: 'El precio de oferta debe ser un número entero o con hasta 3 decimales.',
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: '',
        }));
      }
    }
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const validateForm = async () => {
    let formErrors = {};

    // Validaciones de los campos del formulario
    if (!form.art_codigo || form.art_codigo.trim() === '') {
      formErrors.art_codigo = 'El Código es obligatorio';
    }
    if (Number(tipooferta) === 1) {
      if (!form.aofd_ofertastock || String(form.aofd_ofertastock).trim() === '') {
        formErrors.aofd_ofertastock = 'El Stock asignado a la oferta es obligatorio';
      } else if (Number(form.aofd_ofertastock) === 0) {
        formErrors.aofd_ofertastock = 'El Stock asignado no puede ser 0';
      }
    }

    if (!form.aofd_ofertaprecio) {
      formErrors.aofd_ofertaprecio = 'Se requiere que ingrese el precio o el porcentaje de descuento';
    }

    if (!form.aofd_ofertadescto) {
      formErrors.aofd_ofertadescto = 'Se requiere que ingrese el porcentaje de descuento o el precio';
    }

    // Verificar si hay errores de validación
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return false;
    }

    // Verificar si el artículo ya existe
    const existente = await buscarExistente();
    if (existente && !iddet) {
      formErrors.art_codigo = 'El artículo ya existe, no se puede duplicar';
      setErrors(formErrors);
      return false;
    }

    setErrors({});
    return true; 
  };

  const buscarExistente = async () => {

    // Buscar en el array temporal
    const encontradoArray = arrayDetalle.find(item => item.art_Id === form.art_Id);

    // Buscar en la base de datos si `aofid` está presente
    if (Number(aofid)) {
      const encontradoData = await getOfertaDetPanel(aofid, form.art_Id);
      if (encontradoData.pagination.totalItems > 0) {
        return encontradoData;
      }
    }

    if (encontradoArray) {
      return encontradoArray;
    }

    return null; // Devuelve null si no encuentra el elemento
  };

  const handleSendData = async () => {

    // Validar formulario
    const isFormValid = await validateForm();
    if (!isFormValid) {
      openErrorDialog("Por favor, corrige los errores antes de continuar.");
      return;
    }
    setIsSubmitting(true); 
    try {
      const generateRandomId = () => {
        return Math.floor(Math.random() * 1000000) + Date.now();
      };

      // Dentro del handleSendData
      const idNuevo = selectedRow
        ? selectedRow.id // Si es edición, mantenemos el ID original
        : generateRandomId(); // Generamos un nuevo ID aleatorio para nuevos registros

      // Crear el objeto oferta_Art
      const oferta_Art = {
        id: form.art_Id,
        art_descripcion: form.art_descripcion,
      };

      // Nuevo objeto con oferta_Art incluido
      const newForm = {
        ...form,
        id: idNuevo,
        oferta_Art: oferta_Art,
      };
      delete newForm.art_descripcion;
      if (iddet) {
        const detalleEnArray = arrayDetalle.find((item) => item.id === iddet);
        if (detalleEnArray) {
          await updateItem(detalleEnArray.id, newForm);
          setEstadoForm(1);
        } else {
          try {
            const detalle = await getOfertaDetByIdData(iddet);
            if (detalle) {

              await patchOfertaDetData(detalle.id, newForm);
            } else {
              console.error("No se encontraron datos para el ID proporcionado.");
            }
          } catch (error) {
            console.error("Error al obtener los datos desde la API:", error);
          }
        }
      }
      else {
        await addItem(newForm);
      }

      // Restablecer formulario y cerrar modal
      resetForm();
      closeModal();
    } catch (error) {
      console.error("Error al guardar los datos:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const openErrorDialog = (message) => {
    setErrorMessage(message);
    setIsErrorDialogOpen(true);
  };
  
  const closeErrorDialog = () => setIsErrorDialogOpen(false);


  const resetForm = () => {
    setForm({
      aofd_art_nprecio: '',
      aofd_margen: '',
      aofd_margenactual: '',
      aofd_ofertacosto: '',
      aofd_ofertadescto: '',
      aofd_ofertaprecio: '',
      art_codigo: '',
      art_Id: '',
      art_descripcion: '',
    });
  };

  const handleCancel = () => {
    setSelectedRow('');
    setEstadoForm(0);
    resetForm();
    closeModal();
  };

  return (
    <>
      <div className="topOD">
        <h3>{title}</h3>
      </div>
      <div className="new">
        <div className="newContainerOD">
          <div className="bottomOD">
            <div className="rightOD">
              <form className="OD-form">
                {/* Código de artículo */}
                <div className="formInputOD">
                  {estadoForm === 1 ? (
                    <></>
                  ) : (
                    <>
                      <label>Busqueda</label>
                      <ArticulosModal
                        handleChange={setSearchIdArt}
                        handleDescChange={setSearchDescArt}
                        descSelected={searchIdArt}
                        onSelect={handleSelectArticulo}
                        tipoprecio={tipoprecio}
                      />
                    </>

                  )}
                </div>
                <div className="formInputOD">
                  <label>Codigo</label>
                  <input
                    type="text"
                    name="art_codigo"
                    value={form.art_codigo || ''}
                    placeholder="Código de un artículo"
                    className={`inputNoEditable ${errors["art_codigo"] ? 'inputError' : ''}`}
                    readOnly
                  />
                  {errors["art_codigo"] && <span className="error">{errors["art_codigo"]}</span>}
                </div>
                <div className="formInputOD" style={{ display: 'none' }}>
                  <label>ID OFERTA</label>
                  <input
                    type="int"
                    name="ofcab_id"
                    value={form.ofcab_id || ''}
                    placeholder="Código de un artículo"
                    className={errors["ofcab_id"] ? 'inputError' : ''}
                    readOnly
                    hidden={true}
                  />
                  {errors["ofcab_id"] && <span className="error">{errors["ofcab_id"]}</span>}
                </div>
                {/* Descripción del artículo */}
                <div className="formInputOD">
                  <label>Descripción Del Artículo</label>
                  <input
                    type="text"
                    name="art_descripcion"
                    value={form.art_descripcion || ''}
                    placeholder="Articulo"
                    className={`inputNoEditable ${errors["art_descripcion"] ? 'inputError' : ''}`}
                    onChange={handleInputChange}
                  />
                  {errors["art_descripcion"] && <span className="error">{errors["art_descripcion"]}</span>}
                </div>
                {/* Descripción del artículo */}
                <div className="formInputOD" style={{ display: 'none' }}>
                  <label>ID DEL ARrticulo</label>
                  <input
                    type="int"
                    name="art_Id"
                    value={form.art_Id || ''}
                    placeholder="Articulo"
                    className={errors["art_Id"] ? 'inputError' : ''}
                    onChange={handleInputChange}
                    hidden={true}
                  />
                  {errors["art_Id"] && <span className="error">{errors["art_Id"]}</span>}
                </div>

                {/* Costo + Flete */}
                <div className="formInputOD">
                  <label>Costo + Flete</label>
                  <input
                    type="number"
                    name="aofd_ofertacosto"
                    value={form.aofd_ofertacosto || ''}
                    placeholder="Costo"
                    className={`inputNoEditable ${errors["art_ofertacosto"] ? 'inputError' : ''}`}
                    readOnly
                  />
                  {errors["aofd_ofertacosto"] && <span className="error">{errors["aofd_ofertacosto"]}</span>}
                </div>

                {/* Precio del artículo */}
                <div className="formInputOD">
                  <label>Precio Del Artículo</label>
                  <input
                    type="number"
                    name="aofd_art_nprecio"
                    value={form.aofd_art_nprecio || ''}
                    placeholder="Precio Del Articulo"
                    className={`inputNoEditable ${errors["aofd_art_nprecio"] ? 'inputError' : ''}`}
                    readOnly
                  />
                  {errors["aofd_art_nprecio"] && <span className="error">{errors["aofd_art_nprecio"]}</span>}
                </div>

                {/* Margen actual (%) */}
                <div className="formInputOD">
                  <label>Margen Actual (%)</label>
                  <input
                    type="number"
                    name="aofd_margenactual"
                    value={form.aofd_margenactual || ''}
                    placeholder="Margen Actual (%)"
                    className={`inputNoEditable ${errors["art_margenactual"] ? 'inputError' : ''}`}
                    readOnly
                  />
                  {errors["aofd_margenactual"] && <span className="error">{errors["aofd_margenactual"]}</span>}
                </div>
                <div className="formInputOD">
                </div>
                <div className="formInputOD">
                </div>
                {/* Precio de oferta */}
                <div className="formInputOD">
                  <label>Precio De Oferta</label>
                  <input
                    type="number"
                    name="aofd_ofertaprecio"
                    value={form.aofd_ofertaprecio || ''}
                    placeholder="Precio Oferta Del Articulo"
                    className={errors["aofd_ofertaprecio"] ? 'inputError' : ''}
                    onChange={handleInputChange}
                  />
                  {errors["aofd_ofertaprecio"] && <span className="error">{errors["aofd_ofertaprecio"]}</span>}
                </div>

                {/* Margen de oferta (%) */}
                <div className="formInputOD">
                  <label>Margen Oferta (%)</label>
                  <input
                    type="number"
                    name="aofd_margen"
                    value={form.aofd_margen || ''}
                    placeholder="Ingrese el estado"
                    className={`inputNoEditable ${errors["art_margen"] ? 'inputError' : ''}`}
                    readOnly
                  />
                  {errors["aofd_margen"] && <span className="error">{errors["aofd_margen"]}</span>}
                </div>

                {/* Descuento */}
                <div className="formInputOD">
                  <label>Descuento</label>
                  <input
                    type="number"
                    name="aofd_ofertadescto"
                    value={form.aofd_ofertadescto || ''}
                    placeholder="Ingrese el estado"
                    className={errors["aofd_ofertadescto"] ? 'inputError' : ''}
                    onChange={handleInputChange}
                  />
                  {errors["aofd_ofertadescto"] && <span className="error">{errors["aofd_ofertadescto"]}</span>}
                </div>

                {/* Stock de oferta */}
                <div className="formInputOD">
                  <label
                    style={
                      {
                        color: Number(tipooferta) === 0 && 'red'
                      }
                    }
                  >Stock de Oferta</label>
                  <input
                    type="number"
                    name="aofd_ofertastock"
                    value={form.aofd_ofertastock || ''}
                    placeholder="Stock a disponer"
                    className={errors["aofd_ofertastock"] ? 'inputError' : ''}
                    onChange={handleInputChange}
                    readOnly={Number(tipooferta) === 0} // Solo lectura si tipooferta es 0
                    style={
                      {
                        backgroundColor: Number(tipooferta) === 0 ? '#4334345c' : 'white',
                        color: Number(tipooferta) === 0 && 'white',
                      }
                    }
                  />
                  {errors["aofd_ofertastock"] && <span className="error">{errors["aofd_ofertastock"]}</span>}
                </div>

                {uploadFormError && <span className="error">{uploadFormError}</span>}

                {/* Botones */}
                <div className="btn-fieldOD">
                  <button
                    type="button"
                    className="OD-button"
                    onClick={handleSendData}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Guardando...' : 'Guardar'}
                  </button>
                  <button
                    type="button"
                    className="cancel-buttonOD"
                    onClick={handleCancel}
                    disabled={isSubmitting}
                  >
                    Cancelar
                  </button>
                </div>
              </form>
             
              <ErrorDialog
                isOpen={isErrorDialogOpen}
                onClose={closeErrorDialog}
                message={errorMessage}
                title=""
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormDetalle;
